export const BOOK_ONBOARDING_CALL_CALENDLY_URL =
    'https://calendly.com/plentyfinancial/plenty-early-access';
export const BOOK_MEMBERSHIP_SUPPORT_CALENDLY_URL =
    'https://calendly.com/plentyfinancial/membership-support';
